import React from "react";
import CustomTable from "../../../../../components/table/CustomTable";
import DiningAttendanceHead from "./DiningAttendanceHead";
import DiningAttendanceDayTableApp from "../Functionality/DiningAttendanceDayTableApp";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Software Developer
 * @Email: kpozos@ibl.mx
 *
 * @description
 * Displays a day-based table of dining attendance records. This component integrates search,
 * date filtering, and conditional messages when no data is available. It uses `DiningAttendanceHead`
 * for filter controls and `CustomTable` for rendering the data.
 *
 * @param {Object} props - Component properties.
 * @param {string} props.subView - Current active subview.
 * @param {Function} props.handleBtnDinning - Callback to switch to dining view.
 * @param {Function} props.handleBtnSettings - Callback to switch to settings view.
 * @param {Function} props.handleBtnDepartmentPolicies - Callback to switch to department policies view.
 * @param {Function} props.handleBtnTotalMeals - Callback to switch to total meals view.
 * @param {Array} props.finalArray - Final array of data entries to display.
 * @param {Function} props.setFinalArray - Setter for final data array.
 * @param {Function} props.setBodyForExport - Setter for data used in exports.
 * @param {string} props.searchElement - Value of the current search input.
 * @param {Function} props.setSearchElement - Setter for the search input.
 * @param {Function} props.setSearch - Function to trigger or apply a search.
 * @param {Function} props.setSimpleSearch - Setter for simplified search string.
 * @param {Object} props.selectedOption - Currently selected option for view mode/filter.
 * @param {Function} props.setSelectedOption - Setter for selected option.
 * @param {string} props.color - Optional color theme or status indicator.
 *
 * @returns {JSX.Element} A table view displaying day-based dining attendance data.
 */
const DiningAttendanceDayTable = (props) => {
    const {
        subView,
        handleBtnDinning,
        handleBtnSettings,
        handleBtnDepartmentPolicies,
        handleBtnTotalMeals,
        finalArray,
        setFinalArray,
        setCriteria,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        selectedOption,
        setSelectedOption,
        color,
        modified,
        setModified
    } = props;

    const {
        option,
        rowsPerPage,
        attendanceStartDate,
        attendanceEndDate,
        results,
        setResults,
        selectedDate,
        setSelectedDate,
        pagination,
        tableId,
        searchId,
        thead,
        tbody,
        getData
    } = DiningAttendanceDayTableApp({
        setCriteria,
        setBodyForExport,
        finalArray,
        searchElement,
        selectedOption,
        color,
        modified,
        setModified,
    })

    return (
        <>
            <DiningAttendanceHead
                subView={subView}
                handleBtnDinning={handleBtnDinning}
                handleBtnSettings={handleBtnSettings}
                handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                handleBtnTotalMeals={handleBtnTotalMeals}
                finalArray={finalArray}
                setFinalArray={setFinalArray}
                setBodyForExport={setBodyForExport}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                setResults={setResults}
                results={results}
                option={option}
                rowsPerPage={rowsPerPage}
                attendanceStartDate={attendanceStartDate}
                attendanceEndDate={attendanceEndDate}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                getData={getData}
            />

            <div className={"col-12"}>
                <CustomTable tableId={tableId}
                             searchId={searchId}
                             checkbox={false}
                             thead={thead}
                             tbody={tbody}
                             columnActions={false}
                             textNotInformation={"it_looks_like_the_cafeteria_is_still_waiting_for_its_first_guest"}
                />
            </div>
            {pagination()}
        </>
    );
};

export default DiningAttendanceDayTable;
